// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__tkgY8","fullScreen":"style_fullScreen__a3O5D"};